import { api } from '../lib/api-client';

/**
 * Bill this sale, shared by the booking page (advisors, managers) and the
 * Till's Bookings to receive (cashiers): one API, `sales.sale_bill`. It lives
 * here, not in a feature, because features never import each other
 * (CLAUDE.md §4).
 */

/** The motorcycle invoice that billing would make, with nothing written. Money is a decimal STRING. */
export interface SalePreview {
  lines: {
    lineType: string;
    description: string;
    qty: string;
    unitPrice: string;
    discountAmount: string;
    lineTotal: string;
  }[];
  subtotal: string;
  discountTotal: string;
  taxTotal: string;
  grandTotal: string;
  advancesApplied: string;
  balanceDue: string;
  creditLeft: string;
}

export function previewSale(bookingUid: string): Promise<SalePreview> {
  return api<SalePreview>(`/pos/invoices/from-booking/${bookingUid}/preview`);
}

/** Bills the sale: the invoice is generated from the booking's quotation, never typed. */
export function billSale(bookingUid: string): Promise<{ uid: string; invoiceNo: string }> {
  return api<{ uid: string; invoiceNo: string }>(`/pos/invoices/from-booking/${bookingUid}`, {
    method: 'POST',
    body: {},
  });
}
